import styled from 'styled-components';
import { ReactComponent as RawTopSVG } from '../../../../assets/icons/icon-top30.svg';

export const IconTop = styled(RawTopSVG)``;
